import { render, staticRenderFns } from "./check_customer.vue?vue&type=template&id=6b08a176&scoped=true"
import script from "./check_customer.vue?vue&type=script&lang=js"
export * from "./check_customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b08a176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b08a176')) {
      api.createRecord('6b08a176', component.options)
    } else {
      api.reload('6b08a176', component.options)
    }
    module.hot.accept("./check_customer.vue?vue&type=template&id=6b08a176&scoped=true", function () {
      api.rerender('6b08a176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/order_manage/order_manage/form/components/check_customer.vue"
export default component.exports